import Calendar from "../Calendar";

export default class GoToDayUseCase {
  public static goToDay(day: Date, calendar: Calendar): void {
    calendar.changeView(calendar.getDayViewId());
    calendar.goToDate(day);
  }
}
